exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container__WebloginVehicleInvoicesCard-module___1ADcm .card__WebloginVehicleInvoicesCard-module___Bs_7T {\n    background-color: var(--color-new-white);\n    width: 100%;\n    margin: 0;\n    padding: 22px;\n}", ""]);

// Exports
exports.locals = {
	"container": "container__WebloginVehicleInvoicesCard-module___1ADcm",
	"card": "card__WebloginVehicleInvoicesCard-module___Bs_7T"
};